import React from 'react';
import { ThumbFrame, INK } from './thumbFrame';

/** Neural network hardware accelerator — a chip running a small net. */
const NeuralAccelThumb: React.FC = () => {
  const inputs = [110, 150, 190];
  const hidden = [124, 164, 204];
  const outY = 164;
  return (
    <ThumbFrame label="Neural Network Hardware Accelerator">
      {/* Chip pins */}
      <g stroke={INK} strokeWidth="3" strokeLinecap="round">
        {[124, 150, 176, 202].map((y) => (
          <React.Fragment key={`h${y}`}>
            <line x1="86" y1={y} x2="102" y2={y} />
            <line x1="298" y1={y} x2="314" y2={y} />
          </React.Fragment>
        ))}
        {[150, 176, 202, 228].map((x) => (
          <React.Fragment key={`v${x}`}>
            <line x1={x} y1="70" x2={x} y2="86" />
            <line x1={x} y1="214" x2={x} y2="230" />
          </React.Fragment>
        ))}
      </g>

      {/* Chip body */}
      <rect x="102" y="86" width="196" height="128" rx="12" fill="#ffffff" stroke={INK} strokeWidth="2" />
      <rect x="114" y="98" width="172" height="104" rx="8" fill={INK} opacity="0.03" />

      {/* Edges input -> hidden */}
      <g stroke={INK} strokeWidth="1.2" opacity="0.35">
        {inputs.map((y1) => hidden.map((y2) => <line key={`${y1}-${y2}`} x1="150" y1={y1} x2="204" y2={y2} />))}
      </g>
      {/* Edges hidden -> output */}
      <g stroke={INK} strokeWidth="1.2" opacity="0.35">
        {hidden.map((y1) => (
          <line key={`o${y1}`} x1="204" y1={y1} x2="252" y2={outY} />
        ))}
      </g>

      {/* Signal pulse travelling a path */}
      <circle r="3.5" fill={INK}>
        <animateMotion dur="1.8s" repeatCount="indefinite" path="M150 150 L204 164 L252 164" />
      </circle>
      <circle r="3.5" fill={INK}>
        <animateMotion dur="1.8s" begin="0.6s" repeatCount="indefinite" path="M150 110 L204 124 L252 164" />
      </circle>

      {/* Nodes */}
      {inputs.map((y) => <circle key={`i${y}`} cx="150" cy={y} r="6" fill="#ffffff" stroke={INK} strokeWidth="2" />)}
      {hidden.map((y) => <circle key={`hn${y}`} cx="204" cy={y} r="6" fill="#ffffff" stroke={INK} strokeWidth="2" />)}
      <circle cx="252" cy={outY} r="8" fill={INK} />
    </ThumbFrame>
  );
};

export default NeuralAccelThumb;
